export default class PoktoolsState {
  xPartnerPoktools =
    "lTJaR2Q08Frqq2UK76HqnFH1nFZr9CZRDIdqiCh7qNY=:MjExMjEyMTIxMTIxMjEyMQ==";
  xUserPoktools = "";
  xPassPoktools = "";
  xXeesterLicence = 0;
  xUserPoktoolsBackup = "g/u8CMkRbHDB9L/5/I2k4w==:MjExMjEyMTIxMTIxMjEyMQ==";
  xPassPoktoolsBackup =
    "Ox9w3vdROabFtelS5NX5ru/0FgrSODiXXgYgze8TZSc=:MjExMjEyMTIxMTIxMjEyMQ==";
  licenseDate = 0;
  remainingTime = 0;

  static from(json) {
    let state = JSON.parse(JSON.stringify(json));
    Object.assign(state, json);
    return state;
  }
}
